import type { CookieConsentService } from '../application/CookieConsentService';

const COOKIE_MAX_AGE_IN_SECONDS = 60 * 60 * 24 * 30; // 30 days
const COOKIE_NAME = `cookie_consent`;

export class CookieCookieConsentService implements CookieConsentService {
  get gaveConsent(): boolean {
    return document.cookie.indexOf(COOKIE_NAME) !== -1;
  }

  consent(): void {
    document.cookie = `${COOKIE_NAME}=true;path=/;max-age=${COOKIE_MAX_AGE_IN_SECONDS}`;
  }
}
